import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';

import { Provider } from 'react-redux';
import * as CreDtos from "../../../CRE.dtos";

import TextFormGroup from "../../Controls/TextFormGroup";
import ValidationMessage from "../../Controls/ValidationMessage";
import * as Config from '../../../configuration/consts';
import { required, maxLength, email, minLength } from "../../Validators/";
import {
    updateOn,
    validateOn,
    mapProps,
    showErrors
} from "../../Controls/ReactReduxFormSettings";


@withRouter
export class AddItem extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        this.state = { confirmDelete: false, fileKey: "FileKey" + Date() };
        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
    }

    onDeleteClicked() {
        this.setState({ confirmDelete: !this.state.confirmDelete });
    }

    onCancelClicked() {
        this.props.clearUser();
        this.setState({ fileKey: "FileKey" + Date() });

    }

    onLocalSubmit(values, event) {
        this.onSubmit(values);
    }

    async onSubmit(form) {
        let member = new CreDtos.ForumMemberWithAvatar();
        member = { ...form };
        member.type = form.type ? form.type : this.props.user ? this.props.user.type : "MEMBER";

        if (form.avatarFile && form.avatarFile.length > 0) {
            let file = form.avatarFile[0];
            let attachment = new CreDtos.ForumAttachment();
            attachment.fileName = file.name;
            attachment.fileType = file.type;
            attachment.data = await this.getEncodedFile(file);
            member.avatar = attachment;
        }
        member.obsolete = this.state.confirmDelete;
        let forumId = this.props.forum ? this.props.forum.id : undefined;
        this.props.saveUser(forumId, member);
        this.setState({ fileKey: "FileKey" + Date() });
        if (!this.props.user || !this.props.user.id || this.props.user.id !== this.props.currentUser.id) {
            this.clearUserForm();
        }
    }

    async getEncodedFile(file: File) {
        return new Promise<string>((resolve, reject) => {
            var reader = new FileReader();

            reader.onload = (event: any) => {
                var binaryString = reader.result;
                var encoded = btoa(binaryString);
                resolve(encoded);
            };
            reader.readAsBinaryString(file);
        });
    }
    componentDidMount() {

        if (this.props.user && this.formDispatch) {
            this.formDispatch(actions.change('user', this.props.user));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.user && !this.props.user.id && this.state.confirmDelete) {
            this.onDeleteClicked();
        }
        if ((!prevProps.user && this.props.user) || (prevProps.user && this.props.user && prevProps.user !== this.props.user)) {
            if (this.formDispatch) {
                this.formDispatch(actions.change('user', this.props.user));
                /*if(!this.props.user.type){
                    this.clearUserForm();
                }*/
            }
        } else if (!this.props.user) {
            this.clearUserForm();
        }
    }

    clearUserForm() {
        this.formDispatch(actions.reset('user'));
        this.formDispatch(actions.change('user.type', ''));
    }

    onValueChanged(fieldName: string, value: any) {
        var person = { ...this.state.person };
        person[fieldName] = value;
        this.setState({ person })
    }

    render() {
        const { userRole, currentUser, forum, user, ...props } = this.props;
        let isAdmin = userRole == Config.ROLE_ADMIN;

        let deleteButton = isAdmin && user && user.id ? <a className="btn btn-danger mr-2" onClick={this.onDeleteClicked}>DELETE</a> : undefined;
        let cancelButton = isAdmin ? <button type="reset" className="btn btn-primary mr-2" onClick={this.onCancelClicked}>CANCEL</button> : undefined;
        let actionButtons = this.state.confirmDelete ? <div className="alert alert-warning alert-dismissible fade show">
            <span className="fa fa-warning fa-2x mr-2"></span>
            Are you sure you want to delete this user?
                <a className="btn btn-default mx-2 lightgrey-bg pull-right" onClick={this.onDeleteClicked}>NO</a>
            <button type="submit" className="btn btn-default pull-right">YES</button>
        </div> : <div className="pull-right">{deleteButton}{cancelButton}<button type="submit" className="btn btn-primary">SAVE</button></div>;



        let emailDisabled = user && user.id ? true : false;

        let avatarImg = user && user.forumAttachmentId ?
            `/api/attachment/${user.forumAttachmentId}` :
            require("../../../assets/img/Unconfirmed.png");

        let heading = isAdmin ? user && user.id ? "EDIT MEMBER" : "ADD MEMBER" : "EDIT PROFILE";
        let memberType = isAdmin ? <div className="col-12 mb-1">
            <Control.select model=".type" className="form-control"
                validators={{
                    required: required
                }}
                updateOn={updateOn}
                validateOn={validateOn}>
                <option value=""></option>
                <option value={Config.ROLE_MEMBER}>Member</option>
                <option value={Config.ROLE_ADMIN}>Admin</option>
            </Control.select>
            <Errors
                model=".type"
                messages={{
                    required: "Must select a permission"
                }}
                show={showErrors}
                component={ValidationMessage}
            />
        </div> : undefined;

        let avatarFile = <Control.file model=".avatarFile" id="user.avatarFile" className="form-control" key={this.state.fileKey} />;

        let editAdmin;
        if (currentUser.isAdmin) {
            editAdmin = (
                <div className="col-12 mb-1 ">
                    <label><Control.checkbox model=".isAdmin" id="user.isAdmin" />
                        Is Website Administrator
                    </label>
                </div>
            );
        }

        return (<LocalForm model="user"

            onSubmit={this.onLocalSubmit.bind(this)}
            getDispatch={(dispatch) => this.formDispatch = dispatch}
            validateOn="submit"
            validators={{
                '': {
                    // Form-level validator
                    passwordsMatch: (vals) => { return vals.password === vals.passwordConfirm },
                },
            }}>

            <div className="card lightgrey-bg">
                <div className="card-block">
                    <div className="row">

                        <div className="col-12 col-md-9 push-md-3">
                            <div className="row">
                                <div className="col-12 mb-1 ">
                                    <strong>{heading}</strong>
                                </div>
                                <div className="col-12 mb-1 ">
                                    <Control.text
                                        model=".email"
                                        id="user.email"
                                        component={TextFormGroup}
                                        placeholder="Email..."
                                        validators={{
                                            required: required,
                                            maxLength: maxLength.bind(null, 255),
                                            email: email
                                        }}
                                        updateOn={updateOn}
                                        validateOn={validateOn}
                                        mapProps={mapProps}
                                        maxLength={255}
                                        disabled={emailDisabled}
                                        controlProps={{
                                            validate: true
                                        }}
                                    >
                                        <Errors
                                            model=".email"
                                            messages={{
                                                required: "Email is required",
                                                maxLength: "Email is too long",
                                                email: "Email is not valid"
                                            }}
                                            show={showErrors}
                                            component={ValidationMessage}
                                        />
                                    </Control.text>
                                </div>
                                <div className="col-12 mb-1 ">
                                    <Control.text
                                        model=".firstName"
                                        id="user.firstName"
                                        component={TextFormGroup}
                                        placeholder="First name..."
                                        validators={{
                                            required: required,
                                            maxLength: maxLength.bind(null, 255)
                                        }}
                                        updateOn={updateOn}
                                        validateOn={validateOn}
                                        mapProps={mapProps}
                                        maxLength={255}
                                        controlProps={{
                                            validate: true
                                        }}
                                    >
                                        <Errors
                                            model=".firstName"
                                            messages={{
                                                required: "First name is required",
                                                maxLength: "First name is too long"
                                            }}
                                            show={showErrors}
                                            component={ValidationMessage}
                                        />
                                    </Control.text>
                                </div>
                                <div className="col-12 mb-1 ">
                                    <Control.text
                                        model=".lastName"
                                        id="user.lastName"
                                        component={TextFormGroup}
                                        placeholder="Last name..."
                                        validators={{
                                            required: required,
                                            maxLength: maxLength.bind(null, 255)
                                        }}
                                        updateOn={updateOn}
                                        validateOn={validateOn}
                                        mapProps={mapProps}
                                        maxLength={255}
                                        controlProps={{
                                            validate: true
                                        }}
                                    >
                                        <Errors
                                            model=".lastName"
                                            messages={{
                                                required: "Last name is required",
                                                maxLength: "Last name is too long"
                                            }}
                                            show={showErrors}
                                            component={ValidationMessage}
                                        />
                                    </Control.text>
                                </div>
                                {memberType}
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 mb-1">
                                            <Control.text
                                                model=".password"
                                                id="user.password"
                                                type="password"
                                                component={TextFormGroup}
                                                placeholder="Password..."
                                                validators={{
                                                    maxLength: maxLength.bind(null, 255),
                                                    minLength: minLength.bind(null, 8)
                                                }}
                                                updateOn={updateOn}
                                                validateOn={validateOn}
                                                mapProps={mapProps}
                                                maxLength={255}
                                                controlProps={{
                                                    validate: true
                                                }}
                                            >
                                                <Errors
                                                    model=".password"
                                                    messages={{
                                                        minLength: "Password needs to be at least 8 characters"
                                                    }}
                                                    show={showErrors}
                                                    component={ValidationMessage}
                                                />
                                            </Control.text>
                                        </div>
                                        <div className="col-12 mb-1">
                                            <Control.text
                                                model=".passwordConfirm"
                                                id="user.passwordConfirm"
                                                type="password"
                                                component={TextFormGroup}
                                                placeholder="Confirm Password..."
                                                validators={{
                                                    maxLength: maxLength.bind(null, 255),
                                                    minLength: minLength.bind(null, 8)
                                                }}
                                                updateOn={updateOn}
                                                validateOn={validateOn}
                                                mapProps={mapProps}
                                                maxLength={255}
                                                controlProps={{
                                                    validate: true
                                                }}
                                            >
                                                <Errors
                                                    model=".passwordConfirm"
                                                    messages={{
                                                        minLength: "Password needs to be at least 8 characters"
                                                    }}
                                                    show={showErrors}
                                                    component={ValidationMessage}
                                                />
                                            </Control.text>
                                            <span className="text-danger">
                                                <Errors
                                                    model="user"
                                                    messages={{
                                                        passwordsMatch: "Passwords do not match"
                                                    }}
                                                    show={showErrors}
                                                    component={ValidationMessage}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-1 ">
                                    {avatarFile}
                                </div>
                                {editAdmin}
                                <div className="col-12">
                                    {actionButtons}
                                </div>
                            </div>

                        </div>

                        <div className="col col-12 col-md-3 pull-md-9">
                            <div className="circle-avatar" style={{ width: "125px", height: "125px" }}>
                                <img src={avatarImg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LocalForm>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Member/AddItem.tsx